"use strict";

// regular expression to find html tags
const htmlTagRegex = new RegExp("<(.*)>.?|<(.*) />");

/**
 * Removes HTML tags from a string.
 * @param {string} text - The string to remove HTML tags from.
 * @returns {string} The string without HTML tags.
 */
module.exports = function removeHTMLTags(text) {
    return text.replace(htmlTagRegex, "");
};
